import { useContext, useEffect, useState } from 'react';
import { Modal, Stack, useMediaQuery } from '@mui/material';
import { Theme } from 'Theme';
import { useIsDesktop } from 'Hooks';
import { CloseButton } from './CloseButton';
import { OcrLoading } from './OcrLoading';
import { Form } from './Form';
import {
  AlternativeMedicineContext,
  IAlternativeMedicineInvoice,
} from 'Context/AlternativeMedicine';

export const NewInvoiceForm = () => {
  const { showForm, newInvoice, editedInvoiceIndex } = useContext(
    AlternativeMedicineContext
  );
  const [isLoading, setIsLoading] = useState(true);
  const [OcrInvoice, setOcrInvoice] =
    useState<IAlternativeMedicineInvoice>(newInvoice);

  const isScreenXl = useMediaQuery(Theme.breakpoints.up('xl'));
  const isDesktop = useIsDesktop();

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(
      () => {
        setOcrInvoice(newInvoice); // replace with ocr
        setIsLoading(false);
      },
      editedInvoiceIndex !== null ? 0 : 2000
    );

    return () => {
      clearTimeout(timer);
    };
  }, [newInvoice, editedInvoiceIndex]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  return (
    <Modal
      open={showForm}
      sx={{
        zIndex: '2',
      }}
    >
      <Stack
        sx={{
          width: '100%',
          height: '100%',
          bgcolor: 'white',
          mt: isDesktop ? '80px' : undefined,
          ml: isScreenXl ? '300px' : undefined,
          pl: isDesktop ? (isScreenXl ? '300px' : '72px') : undefined,
          position: 'relative',
          direction: 'ltr',
        }}
      >
        <Stack
          sx={{
            height: isDesktop ? 'calc(100vh - 100px)' : undefined,
            overflowY: isDesktop ? 'scroll' : 'auto',
          }}
        >
          <CloseButton />
          <Form invoice={OcrInvoice} />
        </Stack>
      </Stack>
    </Modal>
  );
};
